import { addDays } from 'date-fns'

/**
 * A document or expiration date counts as "expiring soon" when it expires
 * within this many days. Mirrors `EXPIRING_SOON_DAYS` in the backend's
 * `common/filters.py`, so the client-side status of a row matches what the
 * `expirationStatus` filter would return for it.
 */
export const EXPIRING_SOON_DAYS = 30

export const expirationStatuses = [
  'expired',
  'expiring_soon',
  'valid',
  'missing',
] as const

export type ExpirationStatus = (typeof expirationStatuses)[number]

/**
 * Classify an expiration date. `missing` covers both "no date set" and an
 * unparseable date, so a row always gets exactly one status.
 */
export function getExpirationStatus(
  expirationDate: string | Date | null | undefined,
  now: Date = new Date()
): ExpirationStatus {
  if (!expirationDate) return 'missing'

  const date =
    expirationDate instanceof Date ? expirationDate : new Date(expirationDate)
  if (Number.isNaN(date.getTime())) return 'missing'

  if (date.getTime() < now.getTime()) return 'expired'
  if (date.getTime() <= addDays(now, EXPIRING_SOON_DAYS).getTime()) {
    return 'expiring_soon'
  }

  return 'valid'
}
